import { UseGetProductResponse } from "types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackValidationErrorEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  fieldName: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(
    product,
    `${formTrackingId}:${fieldName}`,
    "validation_error",
    step,
    subStep
  );
};
